export const SaaSPlanColumns = [
    { headerName: 'Nome', field: 'name', filter: true, width: '240' },
    { headerName: 'Preço', field: 'price', type: 'currency', width: '150' },
    { headerName: 'Ciclo', field: 'cycle', type: 'trans', width: '140' },
    { headerName: 'Colaboradores', field: 'maxProfessionals', width: '160' },
    { headerName: 'Filiais', field: 'maxBranches', width: '130' },
];
